import { Table, Button, Tag, Select, DatePicker, Row, Col } from 'antd/lib';
import React from 'react';
import moment from 'moment';
import { imprimirDepositoContravencion } from '../../common/funciones/imprimirReporte';
import { FaCheck, FaPrint, FaEye, FaTrash } from 'react-icons/fa';
import * as Icons from '@ant-design/icons';

const { RangePicker } = DatePicker;

class TablaDepositosContravencion extends React.Component {
  constructor(props) {
    super(props);

    this.state = {
      filterDropdownVisible: false,
      verFiltroApellido: false,
      data: this.props.certificaciones,
      textoBuscarNombre: '',
      textoBuscarApellido: '',
      textoBuscarDocumento: '',
      filtered: false,
    };
  }

  onInputChange = e => {
    this.setState({ textoBuscarNombre: e.target.value });
  };

  onApellidoChange = e => {
    this.setState({ textoBuscarApellido: e.target.value });
  };

  onDocumentoChange = e => {
    this.setState({ textoBuscarDocumento: e.target.value });
  };

  descargar = () => {
    this.props.onDescargar();
  };

  sortFechas = (a, b) => {
    let fechaA = a.fechaDeposito ? a.fechaDeposito : a.fechaCreacion;
    let fechaB = b.fechaDeposito ? b.fechaDeposito : b.fechaCreacion;

    if (fechaA > fechaB) {
      // console.log("A");
      return 1;
    }
    if (fechaA < fechaB) {
      // console.log("B");
      return -1;
    }

    if (fechaA == fechaB) {
      // console.log("C");
      return 0;
    }
  };

  render() {
    let fGeneracion = moment(new Date()).format('DD/MM/YYYY HH:mm');
    const columns = [
      {
        title: 'Fecha',
        key: 'fecha',
        render: record =>
          record.fechaDeposito
            ? moment(record.fechaDeposito).format('DD/MM/YYYY')
            : moment(record.fechaCreacion).format('DD/MM/YYYY'),
        defaultSortOrder: 'descend',
        sorter: (a, b) => this.sortFechas(a, b),
      },
      {
        title: 'Organismo',
        key: 'organismo',
        render: record => record.organismo.nombre,
      },
      {
        title: 'Importe',
        dataIndex: 'importe',
        key: 'importe',
        render: importe =>
          importe.toLocaleString('es-AR', {
            style: 'currency',
            currency: 'ARS',
          }),
      },
      {
        title: 'Sucursal',
        key: 'sucursal',
        dataIndex: 'sucursal',
        render: sucursal => (sucursal ? sucursal.nombre : 'SIN DATOS'),
      },
      {
        title: 'Estado',
        key: 'estado',
        dataIndex: 'estado',
        render: estado => {
          switch (estado) {
            case 'PENDIENTE':
              return (
                <Tag key={estado} color="blue">
                  PENDIENTE
                </Tag>
              );
            case 'DEPOSITADO':
              return (
                <Tag key={estado} color="green">
                  DEPOSITADO
                </Tag>
              );
          }
        },
      },
      {
        title: 'Acciones',
        key: 'acciones',
        render: (text, record) => (
          <span>
            {record.estado == 'PENDIENTE' && (
              <Button
                size="small"
                style={{ marginLeft: 5 }}
                onClick={() =>
                  this.props.history.push(
                    `/administracionGeneral/depositosContravencion/confirmar/${record._id}`
                  )
                }
              >
                <span>
                  <FaCheck />
                </span>
              </Button>
            )}
            <Button
              size="small"
              style={{ marginLeft: 5 }}
              disabled={record.estado != 'DEPOSITADO'}
              type="primary"
              onClick={() => imprimirDepositoContravencion(fGeneracion, record)}
            >
              <span>
                <FaPrint />
              </span>
            </Button>
            <Button
              size="small"
              style={{ marginLeft: 5 }}
              onClick={() =>
                this.props.mostrarModalVerDepositoContravencion(record)
              }
            >
              <span>
                <FaEye />
              </span>
            </Button>
            <Button
              size="small"
              style={{ marginLeft: 5 }}
              type="danger"
              onClick={() => this.props.onDelete(record._id)}
            >
              <span>
                <FaTrash />
              </span>
            </Button>
          </span>
        ),
      },
    ];
    const { depositosContravencionales, usuario, organismos } = this.props;
    return (
      <Table
        rowKey="_id"
        columns={columns}
        dataSource={depositosContravencionales}
        style={{ fontSize: 9 }}
        size="small"
        title={() => (
          <div>
            <h2 style={{ textAlign: 'center' }}>
              Tabla de Depositos Contravencionales
            </h2>
            <Row style={{ display: 'flex', justifyContent: 'space-between' }}>
              <Col>
                <Button
                  style={{ marginRight: 10 }}
                  type="danger"
                  onClick={() => this.props.verTabla(false)}
                >
                  Atras
                </Button>
              </Col>
              <Col>
                <Button
                  style={{ marginRight: 10 }}
                  type="primary"
                  onClick={() => this.props.onDescargar()}
                >
                  <Icons.DownloadOutlined />
                  Descargar Reporte
                </Button>
              </Col>
            </Row>
          </div>
        )}
        locale={{
          emptyText: 'Sin datos de Depositos Contravencionales.',
        }}
      />
    );
  }
}

export default TablaDepositosContravencion;
